import { Badge } from '../atoms/Badge.js';
import { Card } from '../atoms/Card.js';
import { Typography } from '../atoms/Typography.js';

interface InsightCardProps {
  title: string;
  description: string;
  severity: 'high' | 'medium' | 'low';
  confidence?: number;
  className?: string;
}

const severityVariant: Record<string, 'error' | 'warning' | 'info'> = {
  high: 'error',
  medium: 'warning',
  low: 'info',
};

const severityLabel: Record<string, string> = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

export function InsightCard({
  title,
  description,
  severity,
  confidence,
  className = '',
}: InsightCardProps) {
  return (
    <Card className={className}>
      <div className="flex items-start justify-between gap-2">
        <Typography variant="h5">{title}</Typography>
        <Badge variant={severityVariant[severity] ?? 'info'}>
          {severityLabel[severity] ?? severity}
        </Badge>
      </div>
      <Typography variant="body-sm" className="mt-2">
        {description}
      </Typography>
      {confidence != null && (
        <div className="mt-2 text-xs text-neutral-400">
          Confidence: {Math.round(confidence * 100)}%
        </div>
      )}
    </Card>
  );
}
